import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-banner",
  "use": "icon-banner-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"https://www.w3.org/2000/svg\" xmlns:xlink=\"https://www.w3.org/1999/xlink\" id=\"icon-banner\"><path d=\"M878.336 450.624l-163.072-163.072 161.856-161.856c12.032-4.608 20.544-16.064 20.544-29.696 0-17.664-14.336-32-32-32l-768 0c-17.664 0-32 14.336-32 32l0 832c0 17.664 14.336 32 32 32s32-14.336 32-32L129.664 512l727.104 0c10.816 3.648 23.104 1.408 31.744-7.168 6.464-6.464 9.216-14.912 8.832-23.296 0.064-0.576 0.32-1.024 0.32-1.472C897.664 466.816 889.664 455.488 878.336 450.624zM129.664 128l659.072 0-131.712 131.712c-2.88 1.408-5.76 3.008-8.192 5.44-12.096 12.096-12.096 31.808 0 43.968L787.84 448 129.664 448 129.664 128z\" p-id=\"1544\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/banner.svg
// module id = DXJQ
// module chunks = 12